import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { PolicyService } from 'src/app/services/policy.service';

@Component({
  selector: 'upsc-is4ups-multi-carrier-banner',
  templateUrl: './is4ups-multi-carrier-banner.component.html',
  styleUrls: ['./is4ups-multi-carrier-banner.component.scss']
})
export class Is4upsMultiCarrierBannerComponent {

  showIS4UPSBanner:boolean=false;
  constructor(
     private router: Router,
     private userService:UserService,
     private policyService:PolicyService
  ){

  }

  ngOnInit(){
    if(this.userService.isIS4UAcquisitionUser()){
      this.showIS4UPSBanner = true;
    }
    else if (!this.userService.isIS4UAcquisitionUser()
        ||!((this.router?.url == '/dashboard') || (this.router?.url == '/billing')
        || ( /^\/claims(\/.*)?$/.test(this.router?.url) ) || ( /^\/policies(\/.*)?$/.test(this.router?.url) ))) {
      this.showIS4UPSBanner = false;
    }
  }

   gotoCarrier(){
    this.router.navigate(['/multicarrier-coverage']);
  }

}
